export var FacetType;
(function (FacetType) {
    FacetType["DataGrid"] = "DATA_GRID";
    FacetType["Chart"] = "CHART";
    FacetType["PivotTable"] = "PIVOT_TABLE";
})(FacetType || (FacetType = {}));
//# sourceMappingURL=facet_type.js.map